import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

/**
 * PWA install prompt. Shows only after the browser fires beforeinstallprompt
 * and the user hasn't dismissed it in the last 14 days.
 */
export default function InstallBanner() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = Number(localStorage.getItem("pb:install:dismissed") || 0);
    if (Date.now() - dismissed < 14 * 24 * 3600 * 1000) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!visible || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setVisible(false);
  };
  const dismiss = () => {
    localStorage.setItem("pb:install:dismissed", String(Date.now()));
    setVisible(false);
  };

  return (
    <div className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-sm z-50">
      <div className="rounded-md bg-stone-900 border border-amber-500/30 p-4 shadow-2xl flex items-start gap-3">
        <img src="/logo-64.png" alt="" className="w-10 h-10"/>
        <div className="flex-1">
          <div className="font-medium">Install Photo Bridge</div>
          <p className="text-xs text-stone-400 mt-0.5">Review shoots offline from your phone. Zero signal, full sidebar.</p>
          <div className="flex gap-2 mt-3">
            <Button data-testid="btn-pwa-install" onClick={install} size="sm" className="bg-amber-500 text-stone-950 hover:bg-amber-400"><Download className="w-3.5 h-3.5 mr-1.5"/>Install</Button>
            <Button variant="outline" size="sm" onClick={dismiss}>Not now</Button>
          </div>
        </div>
        <button aria-label="Close" onClick={dismiss} className="text-stone-500 hover:text-stone-100"><X className="w-4 h-4"/></button>
      </div>
    </div>
  );
}
